import { CardElement } from '@stripe/react-stripe-js';
import { Box } from '@youversion/design-system-components';
import { useTheme } from 'hooks/useTheme';

import Captcha from './Captcha';

const classes = {
  base: 'bg-white text-text-white border-small dark:text-text-dark dark:bg-canvas-secondary-dark rounded-1 mlb-2 mli-0 pli-2 plb-2 outline-0',
  complete: 'border-green-20',
  empty: 'border-gray-20',
  invalid: 'border-yv-red',
};

const styles = {
  dark: {
    base: {
      '::placeholder': {
        color: 'rgb(158, 161, 162)',
      },
      color: 'rgb(255, 255, 255)',
      fontSize: '16px',
    },
  },
  light: {
    base: {
      '::placeholder': {
        color: 'rgb(119, 122, 123)',
      },
      color: 'rgb(18, 18, 18)',
      fontSize: '16px',
    },
  },
};

interface Props {
  setCaptchaToken: (token: string | null) => void;
}

export default function PaymentMethodsCard({ setCaptchaToken }: Props) {
  const theme = useTheme();

  return (
    <Box>
      <CardElement options={{ classes, style: styles[theme] }} />
      <Captcha setToken={setCaptchaToken} />
    </Box>
  );
}
